import React, { useEffect, useState } from "react";
import { CalendarClock } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { rupiah, relDay } from "@/lib/format";
import { STATUS_BADGE, STATUS_LABEL, PAYMENT_BADGE, PAYMENT_LABEL } from "@/lib/constants";
import { Card, Loading, EmptyState, PageHeader, Badge } from "@/components/common";
import OrderDetailModal from "@/components/OrderDetailModal";

export default function Preorders() {
  const { branch } = useAuth();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [transitions, setTransitions] = useState({});

  const load = async () => {
    setLoading(true);
    try {
      const p = branch ? { branch_id: branch.id } : {};
      const [d, center] = await Promise.all([api.get("/orders/preorders/queue", p), api.get("/orders/center", { ...p, limit: 1 }).catch(() => ({}))]);
      setRows(d); setTransitions(center.transitions || {});
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [branch]);

  return (
    <>
      <PageHeader title="Pre-Order (DP)" subtitle={branch?.name} icon={CalendarClock} />
      {loading ? <Loading /> : !rows.length ? <EmptyState icon={CalendarClock} title="Tidak ada pre-order" message="Pre-order dibuat dari POS dengan DP + tanggal ambil/kirim." /> : (
        <Card className="overflow-hidden">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-slate-400 border-b border-slate-100 bg-slate-50/50">
              <th className="py-3 px-4 font-medium">No Order</th><th className="py-3 px-4 font-medium">Pelanggan</th><th className="py-3 px-4 font-medium">Ambil/Kirim</th>
              <th className="py-3 px-4 font-medium">Status</th><th className="py-3 px-4 font-medium">Bayar</th><th className="py-3 px-4 font-medium text-right">Sisa</th>
            </tr></thead>
            <tbody>
              {rows.map((o) => (
                <tr key={o.id} onClick={() => setSelected(o.id)} className="border-b border-slate-50 hover:bg-primary/5 cursor-pointer" data-testid={`preorder-${o.order_no}`}>
                  <td className="py-3 px-4 font-medium text-slate-800">{o.order_no}</td>
                  <td className="py-3 px-4 text-slate-600">{o.customer_name || "-"}</td>
                  <td className={`py-3 px-4 ${o.is_overdue ? "text-rose-600 font-medium" : "text-slate-600"}`}>{o.due_date ? relDay(o.due_date) : "-"}</td>
                  <td className="py-3 px-4"><Badge className={STATUS_BADGE[o.status]}>{o.status_label || STATUS_LABEL[o.status]}</Badge></td>
                  <td className="py-3 px-4"><Badge className={PAYMENT_BADGE[o.payment_status]}>{PAYMENT_LABEL[o.payment_status]}</Badge></td>
                  <td className="py-3 px-4 text-right font-semibold text-rose-600">{rupiah(o.balance_due)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
      {selected && <OrderDetailModal orderId={selected} transitions={transitions} onClose={() => setSelected(null)} onChanged={load} />}
    </>
  );
}
